<template>
  <div class="document-item">
    <div class="document-item__data">
      <div class="document-item__name">{{ analyse.name }}</div>
      <div v-if="analyse.comment" class="documents-group__description">
        {{ analyse.comment }}
      </div>
    </div>
    <div class="document-item__actions">
      <c-button-2
        :id="`medical-analyse-edit-button-${analyse.name + analyse.id}`"
        class="document-item__edit"
        size="iconic"
        icon="edit"
        @click="$router.push({ name: 'edit-medical-analyse', params: { id: analyse.id } })"
      />
      <c-button-2
        :id="`medical-analyse-remove-button-${analyse.name + analyse.id}`"
        class="document-item__remove"
        size="iconic"
        :icon="{ icon: 'trash', color: 'secondary' }"
        @click="onRemove"
      />
      <c-button-2
        :id="`medical-analyse-sort-button-${analyse.name + analyse.id}`"
        class="document-item__move"
        size="iconic"
        icon="arrows-constructor"
      />

      <b-popover placement="top" triggers="hover" :target="`medical-analyse-edit-button-${analyse.name + analyse.id}`">
        Редактировать
      </b-popover>
      <b-popover
        placement="top"
        triggers="hover"
        :target="`medical-analyse-remove-button-${analyse.name + analyse.id}`"
      >
        Удалить
      </b-popover>
      <b-popover placement="top" triggers="hover" :target="`medical-analyse-sort-button-${analyse.name + analyse.id}`">
        Переместить
      </b-popover>
    </div>
  </div>
</template>

<script>
import Button2 from "@/components/controls2/Button";

export default {
  name: "medical-analyses-group-item",
  components: {
    "c-button-2": Button2,
  },
  props: {
    analyse: {
      type: Object,
      default: () => ({}),
    },
  },
  methods: {
    onRemove() {
      this.$emit("remove");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/vars";
.document-item {
  display: flex;
  align-items: center;
  min-height: 35px;
  padding: 8px 16px;
  // padding-right: 10px;
  border: 1px solid $color-border-light;
  cursor: pointer;


  &__data {
    flex-grow: 1;
    flex-wrap: wrap;
    display: flex;
    align-items: center;
    max-width: calc(90% - 15px);
    word-break: break-word;
  }

  &__name {
    font-size: 13px;
    margin-right: 16px;
  }

  &__colors {
    display: flex;
    margin-right: 16px;
  }

  .document-item__color ~ .document-item__color {
    margin-left: 6px;
  }

  &__criticality {
    font-size: 11px;
    color: $color-secondary;
    margin-right: 16px;
  }

  &__actions {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    margin-left: auto;
  }

  &__edit {
    margin-right: 16px;
  }

  &__remove {
    margin-right: 15px;
    transform: translateY(-2px);
  }
  @media (max-width: 480px) {
    border-right: none;
    &__data {
      flex-direction: column;
      align-items: flex-start;
    }
  }
  @media (min-width: 640px) {
    &__name {
      min-width: fit-content;
      margin-bottom: 3px;
    }
  }
}
.documents-group__description {
  margin-top: 2px;
  padding-right: 10px;
  @media (min-width: 640px) {
    margin-top: 0;
  }
}
.sortable-chosen .document-item {
}
</style>
